import React, {Component} from 'react'
import {$$} from '../../helpers/localization'
import Select from '../shared/Select'
import PropTypes from "prop-types";


class AppointmentsHeader extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="form-inline" style={{'backgroundColor': 'white', "marginBottom": "2.5rem"}}>
                <div className='flex-space-between flex-wrap w-100'>
                    <h2>
                        {$$('my_appointments_label')}
                    </h2>
                    <div className="" style={{'display': 'flex', 'flexWrap': 'wrap'}}>
                        <div className="" style={{'display': 'flex', 'marginRight': '2rem'}}>
                            <Select
                                name="issues-type"
                                options={this.props.filterOptions}
                                value={this.props.pickedOption ? this.props.pickedOption : 0}
                                onChange={this.props.onSelectChange}
                                placeHolder={$$('health_issues_label')}
                                style={{
                                    'minWidth': '-10.188rem',
                                    'minHeight': '2.938rem',
                                    'maxWidth': '18.75rem',
                                    'zIndex': '1',
                                    'opacity': '70%'
                                }}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

AppointmentsHeader.propTypes = {
    filterOptions: PropTypes.array,
    onSelectChange: PropTypes.func,
    pickedOption: PropTypes.any
}

export default AppointmentsHeader
